import * as E from 'fp-ts/lib/Either';
import { config } from '../config';
import {
  insertItem,
  page as commonPage,
  removeItem,
  updateItem,
  singleItem,
  AllowNullKeys,
} from './common';

export type License = {
  _id: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  matchData: Record<string, string>;
  returnData: Record<string, any> | null;
  returnDataString: string;
  deletedAt: string;
};

const format = (partial: unknown): License => {
  if (typeof partial !== 'object' || !partial) {
    throw new Error('Invalid data');
  }

  try {
    const returnDataString = JSON.stringify(
      (partial as Partial<License>).returnData ?? {}
    );
    return { ...partial, returnDataString } as License;
  } catch (e) {
    return { ...partial, returnDataString: '{}' } as License;
  }
};

const formatThroughEither = (
  either: E.Either<Error, Omit<License, 'returnDataString'>>
): E.Either<Error, License> =>
  E.isLeft(either) ? either : E.right(format(either.right));

export const page = (keyId: string) =>
  commonPage<License>(
    `${config.apiUrl}/cms/v1/api-keys/${encodeURIComponent(keyId)}/licenses`,
    format
  );

export const remove = removeItem(`${config.apiUrl}/cms/v1/licenses`);

export const single = async (
  token: string,
  keyId: string,
  id: string
): Promise<E.Either<Error, License>> => {
  const partial = await singleItem<License>(
    `${config.apiUrl}/cms/v1/api-keys/${encodeURIComponent(keyId)}/licenses`
  )(token, id);

  return formatThroughEither(partial);
};

export const insert = async (
  token: string,
  keyId: string,
  record: Partial<License>
) => {
  const partial = await insertItem<License>(
    `${config.apiUrl}/cms/v1/api-keys/${encodeURIComponent(keyId)}/licenses`
  )(token, record);

  return formatThroughEither(partial);
};

export const update = async (
  token: string,
  keyId: string,
  id: string,
  record: Partial<AllowNullKeys<License>>
) => {
  const partial = await await updateItem<License>(
    `${config.apiUrl}/cms/v1/api-keys/${encodeURIComponent(keyId)}/licenses`
  )(token, id, record);

  return formatThroughEither(partial);
};
